import React from 'react';
import { Link } from 'react-router-dom';
import styles from './LandingPage.module.scss';
import { tokens } from '../../styles/tokens';

export const ProblemSection: React.FC = () => {
  return (
    <section className={styles.problemSection}>
      <div className={styles.section}>
        <h3>Why "5 Minutes" Means Nothing</h3>
        <p className={styles.subheadline}>
          Ever wonder why your child ignores your warnings? It's not defiance—it's development.
        </p>

        <div className={styles.statCard}>
          <p>
            "Children under 6 years old can't fully grasp the mathematics of time intervals. 
            To them, '5 minutes' is just a word, not a measurement."
          </p>
          <div style={{ marginTop: '12px', fontSize: '14px', fontWeight: 'bold' }}>— Psychology Today</div>
        </div>

        <div className={styles.statCard} style={{ borderLeftColor: tokens.skyBlue, marginTop: '32px' }}>
          <p>
            "Sudden transitions trigger a fight-or-flight response. Without a visual cue, 
            being told to stop playing feels like a shock, leading to meltdowns."
          </p>
          <div style={{ marginTop: '12px', fontSize: '14px', fontWeight: 'bold' }}>— Dr. Emily King, Child Psychologist</div>
        </div>

        <div style={{ marginTop: '40px' }}>
          <Link to="/science-of-time" style={{ color: tokens.inkBlack, fontWeight: 600, textDecoration: 'underline' }}>
            Read more about the science of kids & time →
          </Link>
        </div>
      </div>
    </section>
  );
};
